import {
  LocalisationConstants,
  OVERRIDE_LOCALE_COOKIE,
} from './localisation.constants'

/**
 * Locale coming from the user account (creator-app sets it once the account is
 * loaded). Kept as a module-level singleton so that the shared date/money
 * helpers can pick it up without knowing which app they run in.
 */
let accountLocale: string | undefined

/*
 * Intl only accepts BCP 47 tags, while the backend may send underscore
 * locales (e.g. `it_IT`). Locales Intl still cannot parse are discarded so a
 * bad account value cannot break every date/money formatting call.
 */
const toIntlLocale = (locale?: string) => {
  if (!locale) return undefined

  const normalisedLocale = locale.replace(/_/g, '-')
  try {
    Intl.DateTimeFormat(normalisedLocale)
    return normalisedLocale
  } catch {
    return undefined
  }
}

export const setAccountLocale = (locale?: string) => {
  accountLocale = toIntlLocale(locale)
}

export const getAccountLocale = () => accountLocale

/**
 * Locale used for Intl formatting (dates, numbers, currencies).
 * Priority: account locale > local override > device locale.
 */
export const getFormattingLocale = (overrideLocale?: string) =>
  overrideLocale ||
  accountLocale ||
  (typeof window !== 'undefined' &&
    localStorage.getItem(OVERRIDE_LOCALE_COOKIE)) ||
  LocalisationConstants.DEVICE_LOCALE

export const LocalisationLocale = {
  setAccountLocale,
  getAccountLocale,
  getFormattingLocale,
}
